import React from "react";
import { getFeaturedNews } from "../utils/NewsUtils";

// firebase
import { onSnapshot, updateDoc, setDoc, doc } from "@firebase/firestore";
import { db } from "../firebase/firebase-config";

// import sections
import Banner from "../components/home/VideoBanner";
import About from "../components/home/About";
import Social from "../components/home/Social";
import JustisNews from "../components/home/JustisNews";
import Loading from "../components/home/Loading";
import Analytics from "../components/home/Analytics";
import Footer from "../components/layouts/Footer";

export default function Home() {
  const [news, setNews] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // function isInToday(inputDate) {
  //   var today = new Date();
  //   if (today.setHours(0, 0, 0, 0) === inputDate.setHours(0, 0, 0, 0)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  /*
   * //!SUBSCRIBE TO NEWS API
   * Checks if news is not in localstorage and get news from google news if and only if back up
   * in firebase's date is not in today. it sets the new to local storage once it fetches from firebase the first time
   */

  // const getNewsItems = () => {
  //   const storedNews = JSON.parse(localStorage.getItem("news"));
  //   const storedTime = JSON.parse(localStorage.getItem("time"));

  //   // CHECK TO SEE IF TIME IN TODAY, IF ITS TODAY FETCH FROM LOCAL STORAGE
  //   if (storedNews != null && isInToday(new Date(storedTime?.seconds * 1000))) {
  //     setNews(storedNews);
  //     console.log("store was called");
  //     return;
  //   } else {
  //     setLoading(true);
  //     onSnapshot(doc(db, "news", "9Z3kKtktK2dnZsoeU1Az"), (d) => {
  //       if (d.exists) {
  //         if (isInToday(new Date(d.data()?.time?.seconds * 1000))) {
  //           console.log("firebase ");
  //           setNews(d.data().news);
  //           localStorage.setItem("news", JSON.stringify(d.data().news));
  //           localStorage.setItem("time", JSON.stringify(d.data().time));
  //         } else {
  //           console.log("news api");
  //           getFeaturedNews().then((items) => {
  //             setNews(items);
  //             updateDoc(doc(db, "news", "9Z3kKtktK2dnZsoeU1Az"), {
  //               news: items,
  //               time: new Date(),
  //             });
  //           });
  //         }
  //       } else {
  //         console.log("news api");

  //         getFeaturedNews().then((items) => {
  //           setNews(items);
  //           setDoc(doc(db, "news", "9Z3kKtktK2dnZsoeU1Az"), {
  //             news: items,
  //             time: new Date(),
  //           });
  //         });
  //       }
  //       setLoading(false);
  //     });
  //   }
  // };

  // React.useEffect(() => {
  //   let mounted = true;

  //   if (mounted) {
  //     getNewsItems();
  //   }

  //   return () => (mounted = false);
  // }, []);

  if (loading) return <Loading />;

  return (
    <main>
      <Banner />
      <About />
      <Analytics />
      <Social />
      <JustisNews />
      <Footer/>
    </main>
  );
}
